module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"tab-settings-title":"Einstellungen","tab-addresses-title":"Addressen"},"fr":{"tab-addresses-title":"Adresses","tab-settings-title":"Paramètres"},"it":{"tab-addresses-title":"Indirizzi","tab-settings-title":"Impostazioni"}}')
  delete Component.options._Ctor
}
